import SectionBenefits from './SectionBenefits'

export default SectionBenefits
